<template>
  <div style="display: flex; justify-content: space-between">
    <div ref="pie_money_chart" style="width: 520px; height: 210px"></div>
    <!-- <div class="chart_list">
      <div v-for="(c, k) in legends" :key="k">
        <div class="chart_list_labels">
          <a-badge :color="colors[k]" />
          {{ c.title }}
        </div>
        <div class="chart_list_values">
          <span class="a_n"><An :number="c.value" /></span>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import An from "@/components/AnimateNumber.vue";

export default {
  components: { An },
  props: {
    graph_data: {
      type: Object,
      required: true,
    },
    timestamp: {
      type: Number,
      required: true,
    },
    event_name: {
      type: String,
      required: false,
      default: "updateData_p",
    },
    translate_key: {
      type: String,
      required: false,
    },
    category: {
      type: String,
      required: false,
    },
  },
  watch: {
    category() {
      this.reload = true;
    },
    timestamp() {
      if (this.reload) {
        setTimeout(() => {
          this.createGraph();
        }, 0);
      } else {
        if (this.evt == null) {
          this.evt = new CustomEvent(this.event_name);
        }
        this.$refs.pie_money_chart.dispatchEvent(this.evt);
      }
    },
  },
  inject: ["colors"],
  data() {
    return {
      legends: [],
      evt: null,

      reload: false,
    };
  },
  methods: {
    createGraph() {
      this.reload = false;

      am4core.options.commercialLicense = true;
      am4core.useTheme(am4themes_animated);
      am4core.options.autoDispose = true;

      var chart = am4core.create(
        this.$refs.pie_money_chart,
        am4charts.PieChart
      );

      chart.innerRadius = am4core.percent(48);
      chart.padding(0, 10, 0, 10);

      chart.language.locale["_thousandSeparator"] = " ";

      const colorsFixes = {
        a : '#fcbf21',
        c : '#fcbf21',
        h : '#fcbf21',
        o : '#fcbf21',
        p : '#fcbf21',
        s : '#fcbf21'
      }




      Object.entries(this.graph_data.tvals).forEach(([key, val]) => {
        this.total += val;
        const data = {
          key: key,
          title: this.translate[this.translate_key][key],
          value: val,
          color: colorsFixes[key]
        };
        chart.data.push(data);
        this.legends.push(data);
      });

      // Add and configure Series
      var pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "title";
      pieSeries.slices.template.stroke = am4core.color("#fff");
      pieSeries.slices.template.strokeWidth = 1;
      pieSeries.slices.template.strokeOpacity = 1;

      // pieSeries.labels.template.disabled = true;
      // pieSeries.ticks.template.disabled = true;

      this.colors.map((color) => {
        pieSeries.colors.list.push(am4core.color(color));
      });

      function generateNumberSequence(start, end, count) {
        const step = (end - start) / (count - 1);

        const sequence = [];
        for (let i = 0; i < count; i++) {
          sequence.push(Math.round(start + step * i));
        }

        return sequence;
      }

      // Usage example
      const start = 100;
      const end = 10;
      const count = 10;

      const sequence = generateNumberSequence(start, end, count);

      const color = "#FF0000";

      for (let i = 0; i < sequence.length; i++) {
        const seq = sequence[i];
        if (seq === 100) {
          pieSeries.colors.list.push(am4core.color(color));
        } else {
          pieSeries.colors.list.push(am4core.color(color + seq));
        }
      }

      pieSeries.labels.template.text = "{value.formatNumber('#,###')} €";

      // This creates initial animation
      pieSeries.hiddenState.properties.opacity = 1;
      pieSeries.hiddenState.properties.endAngle = -90;
      pieSeries.hiddenState.properties.startAngle = -90;

      pieSeries.alignLabels = true;

      // var label = pieSeries.createChild(am4core.Label);
      // label.text = "{value.sum.formatNumber('#,###')} €";
      // label.horizontalCenter = "middle";
      // label.verticalCenter = "middle";
      // label.fontSize = 10;

      chart.legend = new am4charts.Legend();
      chart.legend.itemContainers.template.clickable = false;
      chart.legend.itemContainers.template.focusable = false;
      chart.legend.itemContainers.template.cursorOverStyle =
        am4core.MouseCursorStyle.default;

      chart.legend.autoWidth = false;
      chart.legend.width = 580;
      // chart.legend.maxWidth = 620;

      var marker = chart.legend.markers.template.children.getIndex(0);
      marker.cornerRadius(12, 12, 12, 12);
      var markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 14;
      markerTemplate.height = 14;

      // pieSeries.labels.template.padding(26, 26, 26, 26);

      pieSeries.legendSettings.valueText = "{valueY}";

      // pieSeries.ticks.template.disabled = true;

      // pieSeries.slices.template.setAll({
      //   cornerRadius: 50
      // });

      // pieSeries.ticks.template.setAll({
      //   forceHidden: true
      // });

      this.$refs.pie_money_chart.addEventListener(
        this.event_name,
        () => {
          Object.entries(this.graph_data).forEach(([key, v]) => {
            var index = chart.data.findIndex((s) => s.key == key);

            if (index != undefined) {
              chart.data[index].value = v;
            }
          });

          chart.invalidateRawData();
        },
        false
      );

      // var slice = pieSeries.slices.template;
      // slice.states.getKey("hover").properties.scale = 1;
      // slice.states.getKey("active").properties.shiftRadius = 0;
    },
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
  },
  mounted() {
    setTimeout(() => {
      this.createGraph();
    }, 100);
  },
};
</script>

<style scoped>
.chart_list {
  width: 274px;
  padding-top: 24px;
}
.chart_list_labels {
  display: inline-block;
  vertical-align: top;
  width: 60%;
  padding: 3px;
}
.chart_list_values {
  display: inline-block;
  vertical-align: top;
  width: 40%;
  padding: 3px;
}
</style>